<template>
  <div
    v-if="showNotice"
    class="cookie-consent cookie-notice"
    role="dialog"
    aria-modal="true"
    :aria-label="m.cookieNotice.title"
  >
    <div class="cookie-consent__panel cookie-notice__panel">
      <h2 class="cookie-consent__title">{{ m.cookieNotice.title }}</h2>
      <p class="cookie-notice__subtitle">{{ m.cookieNotice.subtitle }}</p>

      <div class="cookie-notice__content">
        <section v-for="(section, index) in m.cookieNotice.sections" :key="index" class="cookie-notice__section">
          <h3>{{ section.title }}</h3>
          <p v-for="(paragraph, pIndex) in section.body" :key="pIndex">{{ paragraph }}</p>
        </section>

        <section class="cookie-notice__section">
          <h3>{{ m.cookieNotice.tableTitle }}</h3>
          <div class="cookie-notice__table-wrap">
            <table class="cookie-notice__table">
              <thead>
                <tr>
                  <th>{{ m.cookieNotice.tableHeaders.name }}</th>
                  <th>{{ m.cookieNotice.tableHeaders.function }}</th>
                  <th>{{ m.cookieNotice.tableHeaders.type }}</th>
                  <th>{{ m.cookieNotice.tableHeaders.duration }}</th>
                  <th>{{ m.cookieNotice.tableHeaders.purpose }}</th>
                  <th>{{ m.cookieNotice.tableHeaders.legalBasis }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, rowIndex) in m.cookieNotice.rows" :key="rowIndex">
                  <td>{{ row.name }}</td>
                  <td>{{ row.function }}</td>
                  <td>{{ row.type }}</td>
                  <td>{{ row.duration }}</td>
                  <td>{{ row.purpose }}</td>
                  <td>{{ row.legalBasis }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section class="cookie-notice__section">
          <h3>{{ m.cookieNotice.thirdPartyTitle }}</h3>
          <div
            v-for="(service, index) in m.cookieNotice.thirdPartyServices"
            :key="index"
            class="cookie-notice__service"
          >
            <p>{{ service.description }}</p>
            <p>
              {{ service.privacyLabel }}
              <a
                :href="service.privacyUrl"
                class="cookie-notice__link"
                :target="service.openInNewTab === false ? undefined : '_blank'"
                :rel="service.openInNewTab === false ? undefined : 'noopener noreferrer'"
              >{{ service.privacyUrl }}</a>
            </p>
          </div>
        </section>

        <section class="cookie-notice__section">
          <h3>{{ m.cookieNotice.operatorTitle }}</h3>
          <p v-for="(paragraph, index) in m.cookieNotice.operatorBody" :key="index">{{ paragraph }}</p>
        </section>

        <section class="cookie-notice__section">
          <h3>{{ m.cookieNotice.hostingTitle }}</h3>
          <p v-for="(paragraph, index) in m.cookieNotice.hostingBody" :key="index">{{ paragraph }}</p>
        </section>

        <section class="cookie-notice__section">
          <h3>{{ m.cookieNotice.contactTitle }}</h3>
          <p v-for="(paragraph, index) in m.cookieNotice.contactBody" :key="index">{{ paragraph }}</p>
        </section>
      </div>

      <div class="cookie-consent__actions">
        <button type="button" class="cookie-consent__btn cookie-consent__btn--primary" @click="closeNotice">
          {{ m.cookieNotice.close }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { messages: m } = useI18n()
const { showNotice, closeNotice } = useCookieNotice()
</script>